<template>
  <Loading v-if="isLoading" loadingString="Enter Pin" />
  <div
    v-else
    id="mainDiv"
    class="container roundedBorder secondary-bg primary-fg"
  >
    <h2>Enter Pin</h2>

    <div class="row">
      <div class="input-field col s8 m10">
        <i class="material-icons prefix secondary-fg">lock_outline</i>
        <input
          id="icon_prefix"
          class="primary-fg"
          type="text"
          v-model="enteredPin"
        />
        <label for="icon_prefix">PIN</label>
      </div>
      <div class="col s4 m2" style="padding-top: 20px">
        <a
          v-on:click="enterPin"
          class="waves-effect waves-light primary-bg primary-fg btn s12"
          style="width: 100%"
        >
          Submit
          <i class="material-icons left">check</i>
        </a>
      </div>
    </div>

    <span class="secondary-fg">
      Please enter your PIN to access your data.
    </span>
  </div>
</template>

<script>
import M from "materialize-css";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import Loading from "../components/Loading.vue";

export default {
  name: "EnterPin",
  components: {
    Loading
  },
  data: function() {
    return {
      enteredPin: "",
      isLoading: true
    };
  },
  methods: {
    validateCSEEnabled: async function() {
      let enabled = await this.isCSEEnabled();
      if (!enabled) {
        this.$router.push("/pin/initialize");
      }

      this.isLoading = false;
    },
    enterPin: async function() {
      // Check if the entered pin is the correct pin
      try {
        let salt = await this.fetchSalt();
        let hops = this.calculateHash(this.enteredPin, salt);
        let isCorrect = await this.validateHops(hops);

        if (isCorrect) {
          this.setHops(hops);
          this.$router.push("/");
        } else {
          alert("Entered PIN is not correct");
        }
      } catch (err) {
        alert(err);
      }
    }
  },
  mounted: async function() {
    // If there is no user navigate to the root page
    if (!firebase.auth().currentUser) {
      this.$router.push("/");
      return;
    }

    // Initialize the materialize components
    // This also closes the navbar if open
    M.AutoInit();

    await this.validateCSEEnabled();
  },
  metaInfo: {
    title: "Enter Pin",
    meta: [
      {
        name: "description",
        content: "Store encypted passwords with LockerApp."
      },
      { name: "application-name", content: "LockerApp" },
      { name: "author", content: "Emre Biçer" },
      {
        name: "keywords",
        content:
          "LockerApp, Locker App, Locker, App, Password Manager, Password, Safe, Application, Last Password, Locker, Notes, Note Application, Mobile Application, Web Application"
      }
    ]
  }
};
</script>

<style scoped>
#mainDiv {
  padding: 20px;
}

.loading {
  background-image: url("../assets/loading.gif");
  background-size: 100%;
}
</style>
